import React, { useState } from 'react';

const ActivityTimeline = ({ activityTimeline, formatLocalDateTime }) => {
  const [expanded, setExpanded] = useState(false);
  if (activityTimeline.length === 0) return (
    <button
      disabled
      style={{ width: '100%', display: 'block', margin: '0 auto 1rem auto', padding: '1rem', borderRadius: '8px', border: 'none', background: 'rgba(23, 162, 184, 0.1)', color: '#eee', fontWeight: 'bold', cursor: 'not-allowed', opacity: 0.7 }}
    >
        <h2>Activity Logs</h2>
      No recent activity to display.
    </button>
  )
  return (
    <div className="fogged-card" style={{ backgroundColor: 'rgba(23, 162, 184, 0.1)', color: 'white', padding: '1rem', borderRadius: '8px', marginBottom: '1rem' }}>
      <button
        onClick={() => setExpanded(!expanded)}
        style={{ width: '100%', marginBottom: '1rem', padding: '0.5rem 1rem', borderRadius: '6px', border: 'none', background: '#17a2b8', color: '#222', fontWeight: 'bold', cursor: 'pointer', display: 'block' }}
      >
        {expanded ? 'Hide' : 'Show'} Recent Activity Timeline
      </button>
      {expanded && (
        <div style={{ marginTop: '2rem' }}>
          <h3>Recent Activity Timeline</h3>
          <ul>
            {activityTimeline.map((activity, index) => {
              const localTime = formatLocalDateTime(activity.sent_at);
              return (
                <li key={index}>
                  <p><b>A message </b> "{activity.content}" was sent to {activity.recipient_phone_number || activity.recipient_id} at {localTime}</p>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ActivityTimeline;
